/**
 * @format
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PlannedStudies } from 'sis-components/applications/planned-studies-by-study-term/planned-studies-by-study-term.component';
import { AttainedCreditsByStudyTerm } from 'sis-components/service/study-term.service';
import { AutomaticallyFilledExtensionApplicationFields } from '../types';

@Component({
    selector: 'app-extension-application-study-progress-and-plan-info',
    templateUrl: './extension-application-study-progress-and-plan-info.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ExtensionApplicationStudyProgressAndPlanInfoComponent {
    @Input({ required: true }) automaticallyFilledApplicationFields: AutomaticallyFilledExtensionApplicationFields;
    @Input({ required: true }) attainedCreditsByStudyTerm: AttainedCreditsByStudyTerm[];
    @Input({ required: true }) creditsPerTerm: number;
    @Input({ required: true }) plannedStudies: PlannedStudies;
}
